import _ from 'lodash'

export default class Message {
  // text
  // delay

  constructor(msgObject = {}) {
    const {text, delay } = msgObject

    this.text = text || ''
    this.delay = delay || 0
  }

  set text(text) {
    if (_.isString(text)) {
      this._text = text
    } else {
      console.error("Message.text must be string")
      debugger
    }
  }
  get text() { return this._text }

  set delay(val) { this._delay = val }
  get delay() { return (this._delay) }

  toJSON = () => {
    return {
      text: this.text,
      delay: this.delay
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/services/types/Message.js